import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="row-link"
// Makes table rows clickable while still allowing action buttons to work
//
// Usage:
//   <tr data-controller="row-link"
//       data-row-link-url-value="/users/1"
//       data-action="click->row-link#navigate">
//     <td>Name</td>
//     <td><button>Edit</button></td>
//   </tr>
export default class extends Controller {
  static values = {
    url: String
  }

  navigate(event) {
    // Don't navigate if clicking on a link or button
    if (event.target.closest("a, button")) {
      return
    }

    // Don't navigate if text is selected
    if (window.getSelection().toString()) {
      return
    }

    if (this.hasUrlValue) {
      // Use Turbo for navigation
      Turbo.visit(this.urlValue)
    }
  }
}
